import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../../context/AuthContext";
import { genericConverter } from "../../services/firestoreService";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../conf/firebaseConfig";
import { UserProfile } from "../../typings";

export const useCurrentUser = () => {
  const { currentUser } = useAuth();
  return useQuery({
    queryKey: ["user", currentUser?.uid],
    queryFn: () => getUser(currentUser?.uid),
    enabled: !!currentUser?.uid,
  });
};

const getUser = async (userId?: string) => {
  if (!userId) throw new Error("User ID is required");

  const docRef = doc(db, "users", userId).withConverter(
    genericConverter<Partial<UserProfile>>()
  );

  const userDoc = await getDoc(docRef);
  const data = userDoc.data();

  // React Query expects query functions to not return undefined
  // Return null instead when no user document exists
  return data ?? null;
};
